import { useState, useEffect, useCallback } from 'react';
import { useServices } from '@/app/providers';
import type { DirectoryResident, DirectoryParams } from '@yawi/types';
import type { PaginatedResponse } from '@yawi/domain';

export function useDirectory(initialParams?: DirectoryParams) {
  const { guardRepo } = useServices();
  const [data, setData] = useState<PaginatedResponse<DirectoryResident> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [params, setParams] = useState<DirectoryParams>(initialParams || { page: 1, limit: 20 });

  const fetchDirectory = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await guardRepo.getDirectory(params);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar el directorio');
    } finally {
      setLoading(false);
    }
  }, [guardRepo, params]);

  useEffect(() => {
    fetchDirectory();
  }, [fetchDirectory]);

  const search = useCallback((searchTerm: string) => {
    setParams(prev => ({ ...prev, search: searchTerm, page: 1 }));
  }, []);

  const goToPage = useCallback((page: number) => {
    setParams(prev => ({ ...prev, page }));
  }, []);

  return {
    residents: data?.data || [],
    pagination: data?.meta,
    loading,
    error,
    search,
    goToPage,
    refresh: fetchDirectory,
  };
}
